import { render } from "./MailPanel.vue?vue&type=template&id=757fc860&scoped=true"
import script from "./MailPanel.vue?vue&type=script&lang=js"
export * from "./MailPanel.vue?vue&type=script&lang=js"

import "./MailPanel.vue?vue&type=style&index=0&id=757fc860&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-757fc860"]])

export default __exports__